// v0.327.0 (2026-11-04) - THE TEAM PICKER ASKS INSPEC TOO.
// Brett: searching "Add team member" should also search InSpec people; picking
// one brings them into Contacts and onto the team in one press.
//
// What one InSpec row offers, from the import route's status and the company's
// own Contacts. Pure, so it is tested without a browser.
//   on-team  - a contact with this email is already on this team (nothing to do)
//   existing - exactly one contact has this email: add THAT contact, import nothing
//   blocked  - it cannot be told which contact this is; say why, offer nothing
//   import   - bring them in, then add them (warn when a same-named contact exists)

const norm = (s) => String(s || '').trim().toLowerCase();

export function inspecRowAction(p, contacts, teamIds) {
  const email = norm(p && p.email);
  const list = Array.isArray(contacts) ? contacts : [];
  const same = email ? list.filter((c) => norm(c.email) === email) : [];
  if (same.some((c) => teamIds && teamIds.has(c.id))) return { kind: 'on-team' };
  if (same.length === 1) return { kind: 'existing', contact: same[0] };
  if (same.length > 1) {
    return { kind: 'blocked', why: 'Two of your contacts have this email - pick the right one in the list above.' };
  }
  const status = p && p.status;
  if (status === 'ambiguous') {
    return { kind: 'blocked', why: 'More than one of your contacts has this email, so it cannot be told which one this is.' };
  }
  if (status === 'same-email') {
    return { kind: 'blocked', why: 'A contact here already has this email. Press Refresh list, then pick them above.' };
  }
  if (status === 'same-name') return { kind: 'import', warn: 'A contact here has this name - this adds another.' };
  // new, match/linked (this device's list is behind - the server links, never doubles)
  return { kind: 'import' };
}

// The InSpec part of the picker searches from two letters, after a pause.
export const INSPEC_MIN_Q = 2;
export const INSPEC_DEBOUNCE_MS = 400;
export const inspecSearchable = (q) => String(q || '').trim().length >= INSPEC_MIN_Q;

// What the person reads after an InSpec pick, from the import answer. Returns
// { contact } to go on and add, or { note, tone } to stop and say why.
export function importOutcome(body, name) {
  const who = name || 'They';
  if (!body || typeof body !== 'object') return { note: 'The server did not answer with the contact, so nobody was added.', tone: 'error' };
  if (Number(body.capped) > 0) return { note: 'Your plan has no room for another contact, so nobody was brought in.', tone: 'error' };
  if (body.contactsUnread) return { note: `${who} was brought into Contacts - press Refresh list and pick them above.`, tone: 'warn' };
  const c = Array.isArray(body.contacts) ? body.contacts[0] : null;
  if (!c || c.id == null) {
    if (Number(body.ambiguous) > 0) return { note: 'More than one of your contacts has this email, so it cannot be told which one this is.', tone: 'error' };
    if (Number(body.sameEmail) > 0) return { note: 'A contact here already has this email. Press Refresh list, then pick them above.', tone: 'error' };
    if (Number(body.notFound) > 0) return { note: 'InSpec no longer has this person, so nobody was added.', tone: 'error' };
    return { note: 'The server did not answer with the contact, so nobody was added.', tone: 'error' };
  }
  return { contact: c };
}
